import { call, put, takeEvery } from "redux-saga/effects";
// Crypto Redux States
import { GET_BULK_BILLINGS, GET_INVOICES, GET_INVOICE_DETAIL, GET_INVOICE_LIST, SEND_INVOICE } from "./actionTypes";
import {
  getInvoicesSuccess,
  getInvoicesFail,
  getInvoiceDetailSuccess,
  getInvoiceDetailFail,
  sendInvoiceSuccess,
  sendInvoiceFail,
  getInvoiceListSuccess,
  getInvoiceListFail,
  getBulkBillingsSuccess,
  getBulkBillingsFail,
} from "./actions";

//Include Both Helper File with needed methods
import { getInvoices, getInvoiceDetail, sendInvoiceData, getInvoicesList, onGettingBulkBills } from "helpers/fakebackend_helper";
import showToast from "common/Notification";
import { responseHandler } from "common/CommanFunction";

function* onGetBulkBills({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingBulkBills, data);
    yield call(responseHandler, "Bulk Billing", response, getBulkBillingsSuccess, getBulkBillingsFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(getInvoiceListFail(error));
    showToast("error", "Invoice", error);
  }
}

function* fetchInvoiceList({ payload: data }) {
  try {
    const response = yield call(getInvoicesList, data);
    if (response.status) {
      yield put(getInvoiceListSuccess(response));
    } else {
      showToast("warning", "Invoice", "No Data in selected range for invoicing");
    }
  } catch (error) {
    yield put(getInvoiceListFail(error));
    showToast("error", "Invoice", error);
  }
}

function* fetchInvoices({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(getInvoices, data);
    yield call(responseHandler, "Invoice", { status: true, ...response }, getInvoicesSuccess, getInvoicesFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(getInvoicesFail(error));
    showToast("error", "Invoice", error);
  }
}

function* SendInvoiceData({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(sendInvoiceData, data);
    yield call(responseHandler, "Invoice", response, sendInvoiceSuccess, sendInvoiceFail, onSuccess, onError);

    // if (response.status) {
    //   yield put(sendInvoiceSuccess(response));
    //   showToast("success", "Invoice", response.message);
    //   history.push("/invoice");
    // } else {
    //   showToast("success", "Invoice", response.message);
    // }
  } catch (error) {
    onError();
    yield put(sendInvoiceFail(error));
    showToast("error", "Invoice", error);
  }
}

function* fetchInvoiceDetail({ payload: data }) {
  try {
    const response = yield call(getInvoiceDetail, data);
    yield put(getInvoiceDetailSuccess(response));
  } catch (error) {
    yield put(getInvoiceDetailFail(error));
  }
}

function* invoiceSaga() {
  yield takeEvery(GET_INVOICES, fetchInvoices);
  yield takeEvery(GET_INVOICE_DETAIL, fetchInvoiceDetail);
  yield takeEvery(SEND_INVOICE, SendInvoiceData);
  yield takeEvery(GET_INVOICE_LIST, fetchInvoiceList);
  yield takeEvery(GET_BULK_BILLINGS, onGetBulkBills);
}

export default invoiceSaga;
